import { Navigate, useLocation } from 'react-router-dom'

/* AdminHub is verhuisd — content is opgesplitst naar de plek waar het hoort:
   - Live-monitoring, KPIs, waarschuwingen, diagnostics → /regie
   - Setup-snelkoppelingen (LAN-edities, wizard, branding, badges, prijzen…)
     → /admin/setup
   Deze route blijft als redirect zodat oude bookmarks landen op de juiste
   plek — als er een ?tab=X-query hangt aan de oude URL redirecten we naar
   /admin?tab=X (die tab-context leefde vroeger in AdminPage). */
export default function AdminHubPage() {
  const location = useLocation()
  const target = location.search ? `/admin${location.search}` : '/regie'
  return <Navigate to={target} replace />
}
